import { render, staticRenderFns } from "./AlertCompleteField.vue?vue&type=template&id=20996bcf&scoped=true&"
import script from "./AlertCompleteField.vue?vue&type=script&lang=js&"
export * from "./AlertCompleteField.vue?vue&type=script&lang=js&"
import style0 from "./AlertCompleteField.vue?vue&type=style&index=0&id=20996bcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20996bcf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
